const DATE_TIME_PARTS = /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?/;

const pad = (value) => String(value).padStart(2, "0");

// Event DATETIME columns represent the farmer's civil time. MySQL's driver
// serializes them as ISO UTC strings, so they must not be parsed with new Date(value).
export const parseAgriculturalDateTime = (value) => {
  if (!value) return null;
  if (value instanceof Date) return new Date(value.getTime());

  const match = String(value).match(DATE_TIME_PARTS);
  if (match) {
    const [, year, month, day, hour = "00", minute = "00", second = "00"] = match;
    return new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second),
    );
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatAgriculturalDate = (value) => {
  const date = parseAgriculturalDateTime(value);
  if (!date) return "";
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export const formatAgriculturalTime = (value, fallback = "") => {
  const date = parseAgriculturalDateTime(value);
  if (!date) return fallback;
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const buildAgriculturalDateTime = (dateValue, timeValue = "00:00:00") => {
  const value = `${dateValue || ""} ${timeValue || "00:00:00"}`;
  return parseAgriculturalDateTime(value);
};

export const toAgriculturalDatabaseDateTime = (value) => {
  const date = parseAgriculturalDateTime(value);
  if (!date) return null;
  return `${formatAgriculturalDate(date)} ${pad(date.getHours())}:${pad(
    date.getMinutes(),
  )}:${pad(date.getSeconds())}`;
};

export const calendarRangeForAgriculturalEvent = (event) => {
  const rawStart = event?.start_at || event?.raw_start || event?.start;
  const rawEnd = event?.end_at || event?.raw_end || event?.end || rawStart;
  const start = parseAgriculturalDateTime(rawStart);
  const end = parseAgriculturalDateTime(rawEnd) || start;
  const isAllDay = event?.all_day !== undefined
    ? Boolean(event.all_day)
    : Boolean(event?.allDay);

  if (!start || !end) return { start: new Date(), end: new Date(), isAllDay };

  if (!isAllDay) return { start, end, isAllDay: false };

  // react-big-calendar expects an exclusive end for all-day events. The DB end
  // remains inclusive, so 06/10 -> 06/10 appears only on 06/10.
  const displayStart = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const displayEnd = new Date(end.getFullYear(), end.getMonth(), end.getDate() + 1);
  return { start: displayStart, end: displayEnd, isAllDay: true };
};
